<script setup lang="ts">
const { locale } = useI18n()
const { $preview } = useNuxtApp()

const version = $preview ? 'draft' : 'published'

const story = await useAsyncStoryblok(
    'media',
    {
        version: version,
        language: locale.value,
    },
)
</script>

<template>
    <div>
        <StoryblokComponent
            v-if="story"
            :blok="story.content"
        />
    </div>
</template>
